/** Close enough to read the surrounding streets once a store has been picked. */
export const SELECTED_STORE_ZOOM = 15;

/** A delivery address is framed as closely as a picked store, for the same reason. */
export const DELIVERY_ADDRESS_ZOOM = SELECTED_STORE_ZOOM;
